import React from "react";
import { Typography } from "@mui/material";

import { StyledGridLegend } from "./styles";

const ScheduleGraph = ({ ceiling = 125 }) => {
  const steps = ceiling / 25;
  const legend = Array.from({ length: steps + 1 }, (_, i) => ({
    id: i,
    label: `${i * 25}%`,
  }));

  return (
    <StyledGridLegend>
      {legend.map(({ id, label }) => (
        <Typography variant="caption" key={id}>
          {label}
        </Typography>
      ))}
    </StyledGridLegend>
  );
};

export default ScheduleGraph;
